import { useEffect, useState } from "react";
import QuoteForm from "../../parts/quote/Form";
import Api from "../../Api";
import { useNavigate, useParams } from "react-router-dom";
import { intToBrl } from "../../utils";
import Section from "../../parts/Section";
import { Client, Quote, QuoteItem, QuoteAsForm, UIValue } from "../../types";
import DiscreetMessage from "../../parts/DiscreetMessage";

const QuotesAdminUpdate = () => {
  const { uuid } = useParams();
  const navigate = useNavigate();
  const [quote, setQuote] = useState<QuoteAsForm | null>(null);
  const [client, setClient] = useState<Client | null>(null);
  const [error, setError] = useState(false);

  const updateQuote = (key: string) => (value: UIValue | QuoteItem[]) => {
    setQuote((quote) => ({ ...quote!, [key]: value }));
  };

  useEffect(() => {
    Api.myQuotesGetByUuid(uuid!).then(
      ({ quote, client }: { quote: Quote; client: Client }) => {
        setQuote({
          ...quote,
          maxInstallments: quote.maxInstallments.toString(),
          feeMonitoring: intToBrl(quote.feeMonitoring),
          feeInstall: intToBrl(quote.feeInstall),
          feeReview: intToBrl(quote.feeReview),
          discountSale: intToBrl(quote.discountSale),
          discountRent: intToBrl(quote.discountRent),
        });
        setClient(client);
      }
    );
  }, [uuid]);

  const save = async (payload: Quote) => {
    setError(false);
    const result = await Api.myQuotesUpdate(uuid!, payload);
    result.success ? navigate("/aprovar-orcamentos") : setError(true);
  };

  if (!quote || !client) return <DiscreetMessage text="Carregando ..." />;

  return (
    <>
      <div className="border-b">
        <Section
          className="p-4 cursor-pointer group"
          onClick={() => navigate("/aprovar-orcamentos")}
        >
          <div className="text-gray-400 text-sm font-bold">
            Alterando orçamento de
          </div>
          <div className="truncate text-xl font-bold group-hover:text-gray-300">
            {client.name}
          </div>
        </Section>
      </div>

      <QuoteForm
        quote={quote}
        onChange={updateQuote}
        onSave={save}
        buttonLabel="Alterar"
        error={error}
      />
    </>
  );
};

export default QuotesAdminUpdate;
